import React from 'react';
import PropTypes from 'prop-types';
import Button from 'kepler/lib/components/Button';
import Card from 'kepler/lib/components/Card';
import getContent from '../lib/dictionaryFetcher';

/**
 * render all the categories for desktop or laptop screensize.
 * @param {*} props
 */
const DefaultCategoriesHelpful = props => {
  const { helpful, category, callback } = props;

  if (!helpful) return null;

  const heading = getContent(
    'merchanthub',
    `categories.title.helpful.${category}`,
    category
  );

  return (
    <div id="tools-helpful">
      <h2 className="tools-category-heading">{heading}</h2>
      <Card className={`helpful-card ${helpful}`}>
        <div className="helpful-card-icon" />
        <div className="helpful-card-content">
          <h3>
            <span className="helpful-card-icon-sm" />
            {getContent('merchanthub', `apps.${helpful}.title`)}
          </h3>
          <p
            dangerouslySetInnerHTML={{
              __html: getContent('merchanthub', `apps.${helpful}.description`)
            }}
          />
          <Button
            id={`btn-helpful-${helpful}`}
            type="secondary"
            size="sm"
            onClick={() =>
              callback(helpful, {
                fptiLink: `helpful:${helpful}`
              })
            }
          >
            {getContent('merchanthub', `apps.${helpful}.button`, '')}
          </Button>
        </div>
      </Card>
    </div>
  );
};

DefaultCategoriesHelpful.propTypes = {
  helpful: PropTypes.string,
  category: PropTypes.string,
  callback: PropTypes.func
};

export default DefaultCategoriesHelpful;
